import React from 'react';
import { LogOut, HelpCircle } from 'lucide-react';
import { X_API_KEY } from '../../utils/authentication';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { ClusterSwitch } from './ClusterSwitch';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    function changeLanguage( lang ) {
        i18n.changeLanguage(lang);
        localStorage.setItem('i18nextLng', lang);
        window.location.reload();
    }
    const lang = i18n.language;

    return (
    // <button onClick={() => {changeLanguage(lang === "en" ? "cn" : "en")}}>{lang === "en" ? "中文" : "English"}</button>
        <a href="" onClick={ (event) => {event.preventDefault(); changeLanguage(lang.startsWith("en") ? "zh" : "en")}}>{lang.startsWith("en") ? "中文" : "English"}</a>
    )

}

export default class Header extends React.Component {

    constructor() {
        super();

        this.state = {
            apiKey: localStorage.getItem(X_API_KEY)
        }

        this.navItemHandleClick = this.navItemHandleClick.bind(this);
        this.onChangeApiKey = this.onChangeApiKey.bind(this);
    }

    // NOTE: unreferenced since the Navbar was replaced — its only trigger was the
    // Navbar's onSelect, which a plain <header> has no equivalent for. Left in place
    // (along with onChangeApiKey and the apiKey state, dead since the NavDropdown was
    // removed) so this migration stays a pure layout change; safe to delete separately.
    navItemHandleClick(eventKey, event) {

        localStorage.setItem(X_API_KEY, this.state.apiKey);
        window.location.reload();

        // if (eventKey === '1') {
        //     this.props.history.push('/options');
        //     this.props.history.go('/options');
        // }
    }

    onHelp() {

        let url = `${window.location.origin}/docu/index.html`;

        var win = window.open(url, '_blank');
        win.focus();
    }

    onChangeApiKey(event) {
        this.setState({ apiKey: event.target.value });
    }

    renderWarning(msg) {
        return (
            <div style={{transform: "translateX(-50%)", padding: "5px 20px", position: "absolute", top: "10px", left: "50%", borderRadius: "6px", boxShadow: "2px 2px 3px 0 #4f4f4f", fontWeight: "bold", backgroundColor: "red", border: "0px solid blue", color: "white", textAlign: "center"}}>
                {msg}
            </div>
        );
    }

    render() {

        let apiKey = localStorage.getItem(X_API_KEY);
        if (apiKey && apiKey.length > 0) {
            apiKey = "*****" + apiKey.substring(apiKey.length - (apiKey.length > 3 ? 3 : 1));
        } else {
            apiKey = 'PUBLIC';
        }
        const user = { email: "user", apiKey: apiKey };

        let logo = '';
        switch(this.props.brandName){
            case 'BRAND_TCI':
                logo = './images/TCI_Logo.png'
                break;
            case 'BRAND_VLSCH':
                logo = './images/INV_Logo.png'
                break;
            case 'BRAND_PG':
                logo = './images/PG_Logo.png';
                break;
            default:
                logo = './images/INV_Logo.png'
        }

        let msg = '';
        if(this.props.warning.msg === 'undefined' || this.props.warning.msg === ''){
            msg = ''
        } else {
            msg = this.renderWarning(this.props.warning.msg)
        }

        return (
            <header className="flex w-full items-center justify-between gap-4 bg-[#f8f9fa] px-4 py-2">
                <a href="#" className="flex shrink-0 items-center">
                    <img alt="" src={logo} height="22" className="h-[22px] w-auto" />
                </a>
                {msg}
                <div className="flex shrink-0 items-center gap-2 text-sm text-[rgba(0,0,0,0.5)] [&_a]:text-[rgba(0,0,0,0.9)]">
                    <ClusterSwitch />
                    <span>|</span>
                    <LanguageSwitcher />
                    <span>|</span>
                    <Link to='/version' className="mr-6"><Trans i18nKey="Version" /></Link>
                    <HelpCircle className="helpIcon mr-6" onClick={this.onHelp} />
                    <span className="whitespace-nowrap"><Trans i18nKey="Signed_in_as" />: {user.apiKey}</span>
                    <LogOut className="logoutIcon" onClick={this.props.handleOpenLogoutPopup} />
                </div>
            </header>
        );
    }
};
